import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=3f499ae5&scoped=true&"
import script from "./CreateGame.vue?vue&type=script&lang=js&"
export * from "./CreateGame.vue?vue&type=script&lang=js&"
import style0 from "./CreateGame.vue?vue&type=style&index=0&id=3f499ae5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f499ae5",
  null
  
)

export default component.exports